import { isEmptyObject } from './tool';
import qs from 'qs';

/**
 * URL拼接参数
 * @param {string} url  原始URL
 * @param {{[key:string]: string | number}} parameterObj 需要拼接的参数和值，以对象的形式作为参数
 * @returns
 */
export const spliceUrlParameter = (url: string, parameterObj: { [key: string]: string | number }) => {
  if (!url) return url || '';
  if (!parameterObj || isEmptyObject(parameterObj)) return url || '';

  let urlhash = '';
  let delimiterIndex = -1;
  if (url.indexOf('#') > 0) {
    delimiterIndex = url.indexOf('#');
    urlhash = url.substring(url.indexOf('#'), url.length);
  } else {
    urlhash = '';
    delimiterIndex = url.length;
  }
  const sourceUrl = url.substring(0, delimiterIndex);
  const urlParts = sourceUrl.split('?');
  let sourceParameterObj = {};
  if (urlParts.length > 1) {
    sourceParameterObj = qs.parse(urlParts[1]);
  }
  const oldParameterKeys = Object.keys(sourceParameterObj);
  const newParameterKeys = Object.keys(parameterObj);
  let resultParameter = {};
  if (oldParameterKeys.length > 0) {
    resultParameter = { ...sourceParameterObj };
    // 如果old URL 已有该参数，则进行进行替换，没有进行追加
    for (let i = 0, len = newParameterKeys.length; i < len; i++) {
      let itemKey = newParameterKeys[i];
      let itemValue = parameterObj[itemKey];
      if (oldParameterKeys.includes(itemKey)) {
        resultParameter[itemKey] = itemValue;
      } else {
        resultParameter = { ...resultParameter, ...{ [`${itemKey}`]: itemValue } };
      }
    }
  } else {
    resultParameter = { ...parameterObj };
  }
  let newQueryString = qs.stringify(resultParameter);
  if (newQueryString.length > 0) newQueryString = '?' + newQueryString;

  return urlParts[0] + newQueryString + urlhash;
};
